export let am ={
    name:{
      0:"",
      1:"change",
      2:"ESP",
      3:"life saving",
      4:"magical breathing",
      5:"reflection",
      6:"restful sleep",
      7:"strangulation",
      8:"unchanging",
      9:"versus poison"
    },
    ap:{
      0:"circular",
      1:"spherical",
      2:"oval",
      3:"triangular",
      4:"pyramidal",
      5:"square",
      6:"concave",
      7:"hexagonal",
      8:"octagonal"
    }
}

export let ar = {
    name:{
        0: "",
      1: "helmet(kabuto)",
      2: "helm of brilliance",
      3: "helm of opposite alignment",
      4: "helm of telepathy",
      5: "cloak of protection",
      6: "cloak of invisibility",
      7: "cloak of magic resistance",
      8: "cloak of displacement",
      9: "leather gloves",
      10: "gauntlets of fumbling",
      11: "gauntlets of power",
      12: "gauntlets of dexterity",
      13: "speed boots",
      14: "water walking boots",
      15: "jumping boots",
      16: "elven boots",
      17: "kicking boots",
      18: "fumble boots",
      19: "levitation boots",
    },
    ap:{
        0:"etched helmet",
      1:"crested helmet",
      2:"visored helmet",
      3:"plumed helmet",
      4:"tattered cape",
      5:"ornamental cope",
      6:"opera cloak",
      7:"piece of cloth",
      8:"old gloves",
      9:"padded gloves",
      10:"riding gloves",
      11:"fencing gloves",
      12:"mud boots",
      13:"snow boots",
      14:"riding boots",
      15:"buckled boots",
      16:"hiking boots",
      17:"combat boots",
      18:"jungle boots"
    },
    base:{
    0 : "",
    1 : 8,
    2 : 10,
    4 : 30,
    6 : 50,
    7 : 60
    }

}

export let po = {
    ap:{
        0:"ruby",
      1:"pink",
      2:"orange",
      3:"yellow",
      4:"emerald",
      5:"dark green",
      6:"cyan",
      7:"sky blue",
      8:"brilliant blue",
      9:"magenta",
      10:"purple-red",
      11:"puce",
      12:"milky",
      13:"swirly",
      14:"bubbly",
      15:"smoky",
      16:"cloudy",
      17:"effervescent",
      18:"black",
      19:"golden",
      20:"brown",
      21:"fizzy",
      22:"dark",
      23:"white",
      24:"murky",
    },
    base:{
        0 : "",
    1 : 50,
    2 : 100,
    3 : 150,
    4 : 200,
    5 : 250,
    6 : 300,
    7 : "150 or 200"
    },
    name:{
        0:"",
    1:"booze",
    2:"fruit juice",
    3:"see invisible",
    4:"sickness",
    5:"confusion",
    6:"extra healing",
    7:"hallucination",
    8:"healing",
    9:"restore ability",
    10:"sleeping",
    11:"blindness",
    12:"gain energy",
    13:"invisibility",
    14:"monster detection",
    15:"object detection",
    16:"enlightenment",
    17:"full healing",
    18:"levitation",
    19:"polymorph",
    20:"speed",
    21:"acid",
    22:"oil",
    23:"gain ability",
    24:"gain level",
    25:"paralysis"
    }
}

export let ri = {
    name:{
        0: "",
    1: "adornment",
    2: "protection",
    3: "stealth",
    4: "sustain ability",
    5: "hunger",
    6: "warning",
    7: "protection from shape changers",
    8: "gain strength",
    9: "gain constitution",
    10: "increase accuracy",
    11: "increase damage",
    12: "aggravate monster",
    13: "poison resistance",
    14: "cold resistance",
    15: "shock resistance",
    16: "invisibility",
    17: "see invisible",
    18: "regeneration",
    19: "searching",
    20: "levitation",
    21: "fire resistance",
    22: "free action",
    23: "slow digestion",
    24: "teleportation",
    25: "conflict",
    26: "teleport control",
    27: "polymorph",
    28: "polymorph control",
    },
    base:{
        0 : "",
    1 : 100,
    2 : 150,
    3 : 200,
    4 : 300,
    5 : "150 or 200"
    },
    ap:{
        0:"pearl",
    1:"iron",
    2:"twisted",
    3:"steel",
    4:"wire",
    5:"engagement",
    6:"shiny",
    7:"bronze",
    8:"brass",
    9:"copper",
    10:"silver",
    11:"gold",
    12:"wooden",
    13:"granite",
    14:"opal",
    15:"clay",
    16:"coral",
    17:"black onyx",
    18:"moonstone",
    19:"tiger eye",
    20:"jade",
    21:"agate",
    22:"topaz",
    23:"sapphire",
    24:"ruby",
    25:"diamond",
    26:"ivory",
    27:"emerald",
    }
}

export let sc ={
  ap:{
        0:"ZELGO MER",
      1:"JUYED AWK YACC",
      2:"NR 9",
      3:"XIXAXA XOXAXA XUXAXA",
      4:"PRATYAVAYAH",
      5:"DAIYEN FOOELS",
      6:"LEP GEX VEN ZEA",
      7:"PRIRUTSENIE",
      8:"ELBIB YLOH",
      9:"VERR YED HORRE",
      10:"VENZAR BORGAVVE",
      11:"THARR",
      12:"YUM YUM",
      13:"KERNOD WEL",
      14:"ELAM EBOW",
      15:"DUAM XNAHT",
      16:"ANDOVA BEGARIN",
      17:"KIRJE",
      18:"VE FORBRYDERNE",
      19:"HACKEM MUCHE",
      20:"VELOX NEB",
      21:"FOOBIE BLETCH",
      22:"TEMOV",
      23:"GARVEN DEH",
      24:"READ ME",
      25:"ETAOIN SHRDLU",
      26:"LOREM IPSUM",
      27:"FNORD",
      28:"KO BATE",
      29:"ABRA KA DABRA",
      30:"ASHPD SODALG",
      31:"MAPIRO MAHAMA DIROMAT",
      32:"GNIK SISI VLE",
      33:"HAPAX LEGOMENON",
      34:"EIRIS SAZUN IDISI",
      35:"PHOL ENDE WODAN",
      36:"GHOTI",
      37:"ZLORFIK",
      38:"VAS CORP BET MANI",
      39:"STRC PRST SKRZ KRK",
      40:"XOR OTA",
    },
  name:{ 
  0: "",
  1: "identify",
  2: "light",
  3: "enchant weapon",
  4: "enchant armor",
  5: "remove curse",
  6: "destroy armor",
  7: "confuse monster",
  8: "scare monster",
  9: "teleportation",
  10: "gold detection",
  11: "food detection",
  12: "magic mapping",
  13: "fire",
  14: "create monster",
  15: "taming",
  16: "amnesia",
  17: "earth",
  18: "genocide",
  19: "punishment",
  20: "charging",
  21: "stinking cloud",
    },
  base:{
    0 : "",
    1 : 20,
    2 : 50,
    3 : 60,
    4 : 80,
    5 : 100,
    6 : 200,
    7 : 300,
    8 : "60 or 80"
  }
}

export let sp ={
  ap:{0:"parchment",
  1:"vellum",
  2:"ragged",
  3:"dog eared",
  4:"mottled",
  5:"stained",
  6:"cloth",
  7:"leather",
  8:"white",
  9:"pink",
  10:"red",
  11:"orange",
  12:"yellow",
  13:"velvet",
  14:"light green",
  15:"dark green",
  16:"turquoise",
  17:"cyan",
  18:"light blue",
  19:"dark blue",
  20:"indigo",
  21:"magenta",
  22:"purple",
  23:"violet",
  24:"tan",
  25:"plaid",
  26:"light brown",
  27:"dark brown",
  28:"gray",
  29:"wrinkled",
  30:"dusty",
  31:"bronze",
  32:"copper",
  33:"silver",
  34:"gold",
  35:"glittering",
  36:"shining",
  37:"dull",
  38:"thin",
  39:"thick",},
  name:{
    0: "",
    1: "Lv.1 sleep",
    2: "Lv.1 light",
    3: "Lv.1 detect monsters",
    4: "Lv.1 healing",
    5: "Lv.1 knock",
    6: "Lv.1 force bolt",
    7: "Lv.1 protection",
    8: "Lv.1 jumping",
    9: "Lv.2 magic missile",
    10: "Lv.2 confuse monster",
    11: "Lv.2 cure blindness",
    12: "Lv.2 drain life",
    13: "Lv.2 slow monster",
    14: "Lv.2 wizard lock",
    15: "Lv.2 create monster",
    16: "Lv.2 detect food",
    17: "Lv.2 cause fear",
    18: "Lv.3 clairvoyance",
    19: "Lv.3 cure sickness",
    20: "Lv.3 charm monster",
    21: "Lv.3 haste self",
    22: "Lv.3 detect unseen",
    23: "Lv.3 extra healing",
    24: "Lv.3 remove curse",
    25: "Lv.3 identify",
    26: "Lv.3 stone to flesh",
    27: "Lv.4 fireball",
    28: "Lv.4 cone of cold",
    29: "Lv.4 levitation",
    30: "Lv.4 restore ability",
    31: "Lv.4 invisibility",
    32: "Lv.4 detect treasure",
    33: "Lv.5 dig",
    34: "Lv.5 magic mapping",
    35: "Lv.6 turn undead",
    36: "Lv.6 polymorph",
    37: "Lv.6 teleport away",
    38: "Lv.6 create familiar",
    39: "Lv.7 finger of death",
    40: "Lv.7 cancellation",},
    base:{
      0:"",
      1:100,
      2:200,
      3:300,
      4:400,
      5:500,
      6:600,
      7:700,
      8:"300 or 400"
    }
}

export let wa ={
  ap:{
    0:"aluminum",
    1:"balsa",
    2:"brass",
    3:"copper",
    4:"crystal",
    5:"curved",
    6:"ebony",
    7:"forked",
    8:"glass",
    9:"hexagonal",
    10:"iridium",
    11:"iron",
    12:"jeweled",
    13:"long",
    14:"maple",
    15:"marble",
    16:"oak",
    17:"pine",
    18:"platinum",
    19:"runed",
    20:"short",
    21:"silver",
    22:"spiked",
    23:"steel",
    24:"tin",
    25:"uranium",
    26:"zinc",
    },
  name:{
    0:"",
    1: "light",
    2: "nothing",
    3: "secret door detection",
    4: "enlightenment",
    5: "striking",
    6: "make invisible",
    7: "slow monster",
    8: "speed monster",
    9: "undead turning",
    10: "opening",
    11: "locking",
    12: "probing",
    13: "digging",
    14: "magic missile",
    15: "fire",
    16: "cold",
    17: "sleep",
    18: "lightning",
    19: "create monster",
    20: "polymorph",
    21: "cancellation",
    22: "teleportation",
    23: "wishing",
    24: "death",
  },
  base:{
    0 : "",
    1 : 100,
    2 : 150,
    3 : 175,
    4 : 200,
    5 : 500,
    6 : "150 or 200"}
}